export default "__VITE_ASSET__13a3395a__"